import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import {
  BASE_API_URL,
} from "config/consts";
import * as Cookie from "js-cookie";
import { Repository } from "react3l-common";
import appMessageService, {
  messageType,
} from "services/common-services/app-message-service";
import { DecodeToken } from "views/LandingPageView/NewLandingPage";
import moment from "moment";
import jwtDecode from "jwt-decode";
import {  LOGIN_SSO_WAITING_PAGE } from "./route-consts";
export const httpConfig: AxiosRequestConfig = {
  withCredentials: false,
  baseURL: BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
};

Repository.requestInterceptor = function (
  config: AxiosRequestConfig
): AxiosRequestConfig {
  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  } else {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
};

Repository.responseInterceptor = function (
  response: AxiosResponse
): AxiosResponse {
  return response;
};

Repository.errorInterceptor = function (
  error: AxiosError
): void | Promise<void> {
  const requestPath = (
    error?.config?.url ?? error?.response?.config?.url ?? ""
  ).split(/[?#]/)[0];
  const isCountRequest = /(^|\/)count(?:-[^/]+)?\/?$/i.test(requestPath);

  if (error?.response?.status) {
    switch (error.response.status) {
      case 400:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Bạn cần kiểm tra lại các trường dữ liệu",
          description: error.response.statusText,
        });
        break;
      case 401:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Bạn chưa đăng nhập để thực hiện thao tác",
          description: error.response.statusText,
        });
        localStorage.removeItem("currentUserInfo");
        Cookie.remove("Token", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });
        Cookie.remove("access_token", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });
        Cookie.remove("refreshToken", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });

        window.location.href = `${process.env.REACT_APP_KEYCLOAK_URL}/auth?response_type=code&client_id=emp-con-app&redirect_uri=${process.env.REACT_APP_DOMAIN}${LOGIN_SSO_WAITING_PAGE}`;
        break;
      case 403:
        if (
          Cookie.get("access_token") &&
          jwtDecode<DecodeToken>(Cookie.get("access_token")).exp <
            moment.now() / 1000
        ) {
          // window.location.href = LOGIN_ROUTE;
          localStorage.removeItem("currentUserInfo");
          Cookie.remove("Token", {
            domain: `${process.env.REACT_APP_URI_COOKIE}`,
          });
          Cookie.remove("access_token", {
            domain: `${process.env.REACT_APP_URI_COOKIE}`,
          });
          Cookie.remove("refreshToken", {
            domain: `${process.env.REACT_APP_URI_COOKIE}`,
          });
          window.location.href = `${process.env.REACT_APP_KEYCLOAK_URL}/auth?response_type=code&client_id=emp-con-app&redirect_uri=${process.env.REACT_APP_DOMAIN}${LOGIN_SSO_WAITING_PAGE}`;
        } else if (!isCountRequest) {
          appMessageService.messageFactory({
            type: messageType.ERROR,
            title: "Bạn không có quyền thực hiện thao tác này",
            description: error.response.statusText,
          });
        }
        break;
      case 420:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "lỗi BE",
          description: error.response.statusText,
        });
        break;
      case 500:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Lỗi hệ thống",
          description: error.response.statusText,
        });
        break;
      case 502:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Server BE không hoạt động",
          description: error.response.statusText,
        });
        break;
      case 504:
        appMessageService.messageFactory({
          type: messageType.ERROR,
          title: "Phản hồi quá chậm",
          description: error.response.statusText,
        });
        break;
      default:
        break;
    }
  }
  throw error;
};
